import React from 'react';

import DashboardTemplateItem from './DashboardTemplateItem';
import useAppContext from 'flow/hooks/useAppContext';
import { getWallboardTypes } from 'flow/utils/wallboard-utils';

type BoardType = 'hunt_groups_multiple' | 'team_custom';
interface Props {
    onTemplateSelection: (value: string) => void;
}

const DashboardTemplatePicker = ({ onTemplateSelection }: Props) => {
    const { i18next } = useAppContext();

    const renderWallboardTemplateItems = (type: BoardType) => {
        return (
            <div
                className="flex cursor-pointer justify-center"
                onClick={() => onTemplateSelection(type)}
                key={type}
            >
                <DashboardTemplateItem boardType={type} />
            </div>
        );
    };

    return (
        <div className="flex flex-col">
            <h2 className="text-center text-xl font-bold">
                {i18next.t('wallboard.create.template') + ':'}
            </h2>

            <div className="mt-6 flex flex-row flex-wrap content-center justify-center gap-x-4">
                {getWallboardTypes()
                    .map(renderWallboardTemplateItems)
                    .toArray()}
            </div>
        </div>
    );
};

export default React.memo(DashboardTemplatePicker);
